export const cilCheckCircle = ["24 24","<path d='M19.972 4.075c-2.025-2.025-4.823-3.278-7.914-3.278-6.181 0-11.191 5.011-11.191 11.191 0 3.090 1.253 5.888 3.278 7.914v0c2.025 2.025 4.823 3.278 7.914 3.278 6.181 0 11.191-5.011 11.191-11.191 0-3.090-1.253-5.888-3.278-7.914v0zM12.059 21.68c-5.344 0-9.691-4.348-9.691-9.691s4.348-9.691 9.691-9.691 9.691 4.348 9.691 9.691-4.348 9.691-9.691 9.691z'></path><path d='M10.372 14.335l-3.441-3.441-1.061 1.061 4.502 4.502 7.852-7.852-1.061-1.061-6.791 6.791z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-check-circle.js
// module id = null
// module chunks = 